import { PageContainer } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { DuimpRequestForm } from "../../../../components/molecules/DuimpRequestForm";

const DuimpRequest: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer
      backTo="/vbuyer/mm_requests/create_new_requests"
      maxWidth="md"
      showBackButton
      title={t("common.duimpRequest")}
    >
      <DuimpRequestForm />
    </PageContainer>
  );
};

export const Route = createFileRoute("/_private/vbuyer/duimp_requests/new")({
  component: DuimpRequest,
});
